function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.023 85.404c-10.268.151-23.69-.089-33.807-.684-1.35-17.463 5.56-49.52 15.305-59.024-.844 5.854 17.116 56.937 18.502 59.708zM61.977 85.404c10.268.151 23.69-.089 33.806-.684 1.35-17.463-5.56-49.52-15.304-59.024.844 5.854-17.126 56.937-18.502 59.708z",
  fill: "#A51C1C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.737 75.882c-10.179 13.652-20.793 10.081-31.621 1.314C1.025 64.984 3.956 45.212 13.54 28.92c5.01-8.518 20.066-15.935 33.007-15.33 18.325-.48 37.253 6.945 41.925 30.422 3.829 19.248 1.075 29.223-17.729 39.411-5.16 2.798-16.175 2.523-23.005-7.541z",
  fill: "#1C366E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.604 84.898c-1.847.062-3.713-.071-5.196-.826-1.599 0-5.028.48-6.627.48.018.088.054.177.08.257a291.67 291.67 0 00-4.068.089c.098-.134.178-.276.231-.436-1.394-.524-6.866-1.439-7.505-1.439-.045.196-.187.391-.382.587-.116-.045-.231-.09-.338-.125-2.833-1.012-6.369 1.706-7.825 1.057 4.592 6.787 10.223 7.621 17.827 7.746 7.425.115 14.371-2.336 17.791-7.728-2.025-.035-3.188.08-3.988.338z",
  fill: "#294573"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.56 85.182c8.226-3.358 8.865-6.387 12.143-11.894 2.798 5.987 6.395 10.428 12.622 12.187-1.599 0-24.125-.293-24.765-.293z",
  fill: "#294573"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.122 84.862c3.553-.32 5.472-.8 8.5-2.043 2.958 1.315 5.428 1.795 8.448 2.221-2.212.72-6.964.657-8.563.657-1.918.01-5.392-.177-8.385-.835z",
  fill: "#C73A5B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M73.036 58.722c-2.043-.933-4.726-1.83-8.963-2.159-4.52-.346-8.687.569-10.739 1.724-2.815 1.5-5.01 4.743-5.702 6.786v9.149c2.451 5.8 5.587 10.188 12.702 11.263 7.266 1.092 13.341-2.922 14.771-4.69 5.596-7.603 6.351-18.946-2.07-22.073z",
  fill: "#3A61A1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.591 58.722c2.043-.933 4.726-1.83 8.963-2.159 4.52-.346 8.687.569 10.738 1.724 2.816 1.5 5.01 4.743 5.703 6.786v9.149c-2.451 5.8-5.587 10.188-12.702 11.263-7.266 1.092-13.341-2.922-14.771-4.69-5.605-7.603-6.351-18.946 2.07-22.073z",
  fill: "#3A61A1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.428 73.049c-5.427-9.105 13.253-20.82 21.167-11.104 5.374 6.61-12.39 25.804-21.166 11.104zM52.908 61.946c7.905-9.718 26.594 1.998 21.167 11.103-8.776 14.7-26.541-4.495-21.167-11.104z",
  fill: "#4C81C7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.656 7.132c-3.51-1.217-11.859.293-14.825 6.59.63 1.289-1.466 1.005.328 1.138.018-.24.045-.48.09-.702.017.187.035.373.07.577-.177.818 6.813 4.744 10.624 7.009 4.858-.24 5.391-7.435 3.713-14.612z",
  fill: "#36B8FF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.349 11.964L80.078 24.95c8.998-7.364 4.663-16.21 3.704-18.36-.169-.373-.32-.693-.462-.96a3.138 3.138 0 00-2.38-1.66c-15.483-2.034-18.591 7.994-18.591 7.994zm4.592 2.362s1.021-6.457 10.952-5.782a2.28 2.28 0 011.91 1.27c1.11 2.292 2.744 7.586-2.87 11.912l-9.992-7.4z",
  fill: "#1C366E"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.211 13.314c-5.125 1.91-14.531 9.744-15.17 9.744-1.68-1.44-5.437-3.677-5.588-8.492.329-9.051 15.802-11.556 20.758-1.252z",
  fill: "#36B8FF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.14 3.979a3.131 3.131 0 00-2.381 1.66c-.142.267-.293.587-.462.96-.96 2.15-5.294 10.997 3.704 18.36l17.73-12.995S30.62 1.936 15.138 3.979zm4.005 17.756c-5.622-4.326-3.988-9.62-2.869-11.912a2.28 2.28 0 011.91-1.27c9.93-.675 10.952 5.783 10.952 5.783l-9.993 7.399z",
  fill: "#1C366E"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.044 40.619c1.599-.56 2.958-.72 3.917-4.077.8 2.398.32 5.596-1.279 7.026-.817.187-2.451-2.167-2.638-2.949z",
  fill: "#CAD7E1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.162 43.017c-1.758-3.41-6.475-3.668-9.024-3.668-2.949 2.211-3.073 7.266-3.962 10.366-2.256-3.678-5.4-8.04-5.827-8.04-.968.978-3.162 3.438-4.876 6.059-1.261 1.812-2.398 3.677-2.913 5.151v1.92h9.584c.96 0 5.027.026 5.986.026 0-.01-.008-.018-.008-.027h2.647c5.969-.746 9.175-6.058 8.393-11.787z",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M67.945 52.859a7.32 7.32 0 100-14.638 7.32 7.32 0 000 14.638z",
  fill: "#478CF5"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M67.946 51.234a5.694 5.694 0 100-11.387 5.694 5.694 0 000 11.387z",
  fill: "#EAAA20"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M67.945 48.036a2.496 2.496 0 100-4.992 2.496 2.496 0 000 4.992z",
  fill: "#331E1B"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.162 43.017c-1.963-5.036-6.333-7.719-7.674-8.438-.044-.027-.098-.053-.142-.08-.169-.089-.267-.133-.267-.133l.01.009c-.045-.018-.09-.045-.125-.063-7.506-3.135-14.78 2.168-17.161 10.002v-.009c-.888 2.816-1.395 8.092-1.226 9.815.125-1.066.755-2.282 1.35-3.233 2.603-3.695 10.224-15.127 24.676-8.367.444.222.56.497.56.497z",
  fill: "#C44BFF"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.44 40.619c-1.6-.56-2.958-.72-3.918-4.077-.8 2.398-.32 5.596 1.28 7.026.817.187 2.451-2.167 2.637-2.949z",
  fill: "#CAD7E1"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.696 48.756a22.225 22.225 0 00-3.225-4.38c-.995-1.234-1.865-2.22-2.336-2.7-.062 0-.186.107-.355.303-3.287-2.434-7.799-4.175-13.786-3.651-.56.08-1.58.933-2.38 2.371-.942.534-1.75 1.28-2.292 2.319-.781 5.729 2.425 11.04 8.385 11.796h2.638c0 .009-.009.017-.009.026.96 0 5.028-.026 5.987-.026h9.584v-1.919c-.408-1.199-1.243-2.656-2.211-4.14z",
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M28.08 52.903a7.32 7.32 0 100-14.638 7.32 7.32 0 000 14.638z",
  fill: "#478CF5"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M28.081 51.278a5.694 5.694 0 100-11.387 5.694 5.694 0 000 11.387z",
  fill: "#EAAA20"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M28.08 48.08a2.496 2.496 0 100-4.992 2.496 2.496 0 000 4.992z",
  fill: "#331E1B"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.806 44.696c-.036-.133-.08-.267-.115-.4v.01c-2.381-7.844-9.656-13.138-17.161-10.002-.036.017-.08.044-.125.062l.01-.01s-.099.045-.267.134c-.045.027-.098.053-.142.08-1.342.728-5.72 3.402-7.675 8.438 0 0 .116-.284.577-.506 14.426-6.742 22.047 4.654 24.658 8.358.604.95 1.235 2.177 1.36 3.242.15-1.634-.303-6.51-1.12-9.406z",
  fill: "#C44BFF"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.455 20.42c-1.857-1.856-7.444-6.111-13.368-8.74-.107-.036-4.948-1.67-7.15-1.91-8.341-1.528-16.327-.56-22.411 1.91-.01 0-.24.106-.356.16-7.186 3.348-11.582 6.768-13.9 8.962-.018.018-5.02 4.583-6.858 8.865 6.04-6.28 12.515-7.577 16.815-8.838 6.066-1.777 13.003-2.736 14.194-2.7 4.672-.64 11.298.026 11.307.017 2.71.284 6.706.533 12.4 2.07 4.592 1.243 12.24 2.522 16.566 9.53-2.105-4.583-5.17-7.247-7.24-9.326z",
  fill: "#E62E2D"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.113 26.576c.098-.107.186-.204.258-.31.302-.4.595-.96.64-1.688l-.4-.96-1.155.853-.142.453c-1.137 2.496-5.88 1.972-7.844-.95-.675.017-1.359.586-1.057.888.63 1.519 3.411 2.904 6.271 2.904 1.377 0 2.354-.373 3.003-.835v.018s.07-.044.168-.133c.08-.062.134-.124.205-.187a.149.149 0 00.053-.053zM29.6 23.974c-1.963 2.922-6.706 3.446-7.843.95l-.142-.453-1.155-.853-.4.96c.045.728.338 1.287.64 1.687.071.107.16.204.258.311.017.018.026.036.044.044.062.063.124.125.196.187.097.089.168.133.168.133v-.018c.649.462 1.626.835 3.003.835 2.86 0 5.64-1.385 6.27-2.904.32-.293-.364-.87-1.039-.88zM52.818 25.252l.516.471c3.854 2.63 7.638 2.203 9.157-.968.356.275 1.848-.044 1.875.4-.285.648-.791 2.487-2.772 3.5-1.004.506-5.516 1.26-9.193-1.555l-.604-.373 1.021-1.475zM43.261 25.252l-.515.471c-3.855 2.63-7.639 2.203-9.158-.968-.355.275-1.848-.044-1.874.4.284.648.79 2.487 2.771 3.5 1.004.506 5.516 1.26 9.194-1.555l.603-.373-1.02-1.475z",
  fill: "#DB9925"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M15.145 27.307c.932-1.305 1.465-2.522 1.19-2.72-.275-.196-1.255.702-2.188 2.007-.933 1.305-1.466 2.523-1.19 2.72.275.196 1.254-.702 2.188-2.007z",
  fill: "#DB9925"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M17.456 25.909c.905-1.324 1.39-2.568 1.082-2.779-.308-.21-1.291.693-2.197 2.017-.906 1.324-1.39 2.568-1.083 2.778.308.21 1.292-.692 2.198-2.016z",
  fill: "#DB9925"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M20.026 24.933c.951-1.291 1.339-2.621.865-2.97-.474-.35-1.63.414-2.581 1.706-.952 1.292-1.339 2.622-.865 2.971.474.35 1.63-.415 2.581-1.707z",
  fill: "#DB9925"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M23.655 23.914c1.126-1.144 1.52-2.581.88-3.21-.64-.63-2.071-.214-3.197.929-1.125 1.143-1.518 2.58-.879 3.21.64.63 2.071.214 3.196-.93z",
  fill: "#DB9925"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M28.01 22.665c1.236-1.022 1.66-2.552.944-3.418-.716-.866-2.298-.74-3.535.281-1.237 1.022-1.66 2.552-.944 3.418.715.866 2.298.74 3.535-.281z",
  fill: "#DB9925"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M32.773 21.442c1.344-.875 1.911-2.387 1.266-3.378-.645-.991-2.257-1.085-3.602-.21-1.344.875-1.911 2.388-1.266 3.379.645.99 2.257 1.084 3.602.21z",
  fill: "#DB9925"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M37.519 20.74c1.537-.458 2.486-1.828 2.12-3.06-.367-1.231-1.91-1.859-3.448-1.401-1.538.457-2.486 1.827-2.12 3.059.367 1.232 1.91 1.86 3.448 1.401z",
  fill: "#DB9925"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M43.113 20.284c1.546-.43 2.503-1.843 2.138-3.157-.365-1.314-1.914-2.03-3.46-1.601-1.545.429-2.502 1.842-2.137 3.156.365 1.314 1.914 2.031 3.46 1.602zM83.13 29.309c.276-.197-.258-1.415-1.19-2.72-.934-1.305-1.913-2.203-2.189-2.006-.275.197.258 1.414 1.191 2.72.933 1.304 1.913 2.203 2.188 2.006z",
  fill: "#DB9925"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M80.823 27.922c.308-.21-.177-1.454-1.082-2.778-.906-1.324-1.89-2.227-2.198-2.016-.307.21.177 1.454 1.083 2.778.906 1.324 1.89 2.227 2.197 2.017z",
  fill: "#DB9925"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M78.645 26.637c.475-.349.087-1.68-.864-2.97-.951-1.293-2.107-2.057-2.58-1.707-.475.349-.088 1.679.864 2.97.95 1.292 2.106 2.056 2.58 1.707z",
  fill: "#DB9925"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M75.63 24.845c.639-.63.245-2.067-.88-3.21-1.125-1.144-2.556-1.56-3.196-.93-.64.63-.246 2.067.88 3.21 1.124 1.143 2.555 1.56 3.195.93z",
  fill: "#DB9925"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M71.605 22.942c.716-.866.293-2.396-.944-3.417-1.237-1.022-2.82-1.148-3.535-.282-.715.866-.292 2.397.944 3.418 1.237 1.022 2.82 1.148 3.535.281z",
  fill: "#DB9925"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M66.904 21.234c.645-.99.078-2.503-1.266-3.378-1.345-.875-2.957-.782-3.602.21-.645.99-.078 2.503 1.267 3.378 1.344.875 2.957.781 3.602-.21z",
  fill: "#DB9925"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M62.006 19.347c.367-1.232-.583-2.602-2.12-3.06-1.537-.457-3.08.17-3.448 1.402-.366 1.232.583 2.602 2.12 3.06 1.538.457 3.081-.17 3.448-1.402z",
  fill: "#DB9925"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M56.43 18.684c.366-1.314-.591-2.727-2.137-3.156-1.546-.43-3.094.288-3.46 1.602-.364 1.314.593 2.727 2.138 3.156 1.546.43 3.095-.288 3.46-1.602z",
  fill: "#DB9925"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M48.04 20.047c1.604 0 2.904-1.122 2.904-2.505 0-1.383-1.3-2.505-2.905-2.505-1.604 0-2.904 1.122-2.904 2.505 0 1.383 1.3 2.505 2.904 2.505z",
  fill: "#DB9925"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M33.689 25.989c1.79-.861 2.684-2.72 1.995-4.152-.688-1.433-2.698-1.897-4.488-1.036-1.791.86-2.685 2.72-1.996 4.152.688 1.433 2.698 1.896 4.489 1.036z",
  fill: "#F1A902"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M33.347 25.276c1.295-.623 1.94-1.97 1.441-3.009-.5-1.039-1.954-1.377-3.25-.754-1.295.623-1.94 1.97-1.441 3.009.499 1.039 1.954 1.377 3.25.754z",
  fill: "#C7842C"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M33.02 24.595c.826-.397 1.238-1.257.92-1.92-.32-.663-1.248-.879-2.075-.482-.827.398-1.238 1.258-.92 1.92.32.664 1.248.88 2.075.482zM67.033 24.59c.526-1.5-.568-3.249-2.442-3.907-1.875-.657-3.821.025-4.347 1.525-.526 1.5.567 3.249 2.441 3.907 1.875.657 3.822-.025 4.348-1.525z",
  fill: "#F1A902"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M66.094 24.261c.381-1.088-.409-2.355-1.765-2.831-1.356-.476-2.765.02-3.147 1.108-.382 1.088.409 2.355 1.765 2.831 1.356.476 2.765-.02 3.147-1.108z",
  fill: "#C7842C"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M65.205 23.95c.243-.695-.261-1.504-1.127-1.807-.865-.304-1.765.013-2.008.707-.244.694.26 1.504 1.126 1.807.866.304 1.765-.013 2.009-.707zM48.04 29.933c2.82 0 5.107-2.036 5.107-4.547 0-2.512-2.286-4.548-5.107-4.548-2.82 0-5.107 2.036-5.107 4.548 0 2.511 2.286 4.547 5.107 4.547z",
  fill: "#F1A902"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M48.04 28.672c2.04 0 3.695-1.472 3.695-3.287S50.08 22.1 48.04 22.1c-2.04 0-3.695 1.471-3.695 3.286s1.654 3.287 3.695 3.287z",
  fill: "#C7842C"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M48.04 27.722c1.452 0 2.63-1.046 2.63-2.336 0-1.29-1.178-2.336-2.63-2.336s-2.629 1.046-2.629 2.336c0 1.29 1.177 2.336 2.63 2.336z",
  fill: "#F1A902"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M48.04 37.013a3.535 3.535 0 100-7.07 3.535 3.535 0 000 7.07z",
  fill: "#FFB516"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M48.04 35.876a2.398 2.398 0 100-4.797 2.398 2.398 0 000 4.797z",
  fill: "#E43330"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M47.125 33.797a1.013 1.013 0 100-2.026 1.013 1.013 0 000 2.026z",
  fill: "#FDFBFA"
});

var SvgKatrina = function SvgKatrina(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKatrina, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/katrina.70253a80.svg";
export { ForwardRef as ReactComponent };